import { Box, Breadcrumbs, Link, Typography } from "@mui/material";
import { FC } from 'react';
import { Link as RouterLink } from 'react-router-dom';

interface EventEditorNavigationProps {
    eventTitle?: string;
    isNewEvent: boolean;
}

const EventEditorNavigation: FC<EventEditorNavigationProps> = ({
    eventTitle,
    isNewEvent
}) => {
    return (
        <Box sx={{ mb: 3 }}>
            <Breadcrumbs>
                <Link component={RouterLink} to="/admin/events" underline="hover">
                    Events Administration
                </Link>
                <Typography color="text.primary">
                    {isNewEvent ? 'Create New Event' : (eventTitle || 'Edit Event')}
                </Typography>
            </Breadcrumbs>
        </Box>
    );
};

export default EventEditorNavigation;
